/**
 * Like Setup - Initialization and Dependency Injection
 * Standardized setup pattern (Pattern B)
 */

import { LikeApiService } from "./like-api";
import { LikeForm } from "./like-form";
import { LikeHandler } from "./like-handler";
import { LikeListener } from "./like-listener";
import { LikeRender } from "./like-render";

interface LikeSetupResult {
    apiService: typeof LikeApiService;
    form: LikeForm;
    uiManager: LikeRender;
    handler: LikeHandler;
    listener: LikeListener;
}

class LikeSetup {
    public static init(): LikeSetupResult {
        const apiService = LikeApiService;
        const form = new LikeForm();
        const uiManager = new LikeRender(form);
        const handler = new LikeHandler(apiService, uiManager, form);
        const listener = new LikeListener(handler);

        listener.setup();

        return { apiService, form, uiManager, handler, listener };
    }
}

function initLikeSystem(): void {
    LikeSetup.init();
}

export { LikeSetup, initLikeSystem };
